import { apiUrl } from '../config/api'
import '../config/httpInterceptor'

export async function getOffPlatformOrder(orderId) {
  const resp = await fetch(apiUrl(`/api/captain/off-platform-orders/${orderId}`))
  if (resp.status === 401) return { status: 401 }
  if (resp.status === 403) return { status: 403 }
  if (resp.status === 404) return { status: 404 }
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
  const body = await resp.json()
  return { status: 200, body }
}

export async function claimOffPlatformOrder(orderId) {
  const resp = await fetch(apiUrl(`/api/captain/off-platform-orders/${orderId}/claim`), { method: 'POST' })
  if (resp.status === 409) return { status: 409 }
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
  const body = await resp.json()
  return { status: 200, body }
}
